import Link from 'next/link'
import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import { Container, ToggleButton } from './styles'

type Props = {
  kitHandle: string
}

export const KitToggle: FC<Props> = ({ kitHandle }) => {
  const {
    pages: {
      product: { joggerSet, straightLegSet },
    },
  } = useTranslation()

  const isWomensJoggerSet = kitHandle === 'womens-the-set'
  const isWomensStraightLegSet = kitHandle === 'womens-the-set-kade'

  const joggerSetLink = '/kits/womens-the-set'
  const straightLegSetLink = '/kits/womens-the-set-kade'

  const showToggle = isWomensJoggerSet || isWomensStraightLegSet

  if (!showToggle) return null

  return (
    <Container>
      <ToggleButton as={Link} href={joggerSetLink} isSelected={isWomensJoggerSet}>
        {joggerSet}
      </ToggleButton>
      <ToggleButton as={Link} href={straightLegSetLink} isSelected={isWomensStraightLegSet}>
        {straightLegSet}
      </ToggleButton>
    </Container>
  )
}
